export function stringAvatar(name: string) {
  if (!name) return { sx: { bgcolor: 'divider' }, children: '??' };

  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';
  for (let i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  const splitName = name.split(' ');
  const initials = splitName.length > 1
    ? `${splitName[0][0]}${splitName[1][0]}`
    : `${name[0]}`;

  return {
    sx: { bgcolor: color, color: '#fff', fontSize: '0.75rem', fontWeight: 'bold' },
    children: initials.toUpperCase(),
  };
}